// Module
var code = "<div id=\"V-D0870D0F-FC01-40C4-B9A8-686966C8FB90\"> <select class=\"combo\" data-b-component=\"combo\" data-b-comp-items=\"{Binding items}\" data-b-comp-selected=\"{Binding selecteditem}\"> <option class=\"template\"> {Binding value} </option> </select> </div> ";
// Exports
export default code;